// extracted by mini-css-extract-plugin
module.exports = {"MobileControls":"_9FeIr","MobileControls__Block":"vZuL6","MobileControls__ModalContent":"bGKod","MobileControls__ListSwitch":"_3YCqi"};